var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleDown = function SvgAngleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m362.7 203.9-159.1 144a16.06 16.06 0 0 1-21.44 0l-160.87-144c-6.56-6.8-7.09-16-1.19-22.6 6.28-6.9 16.4-6.8 22.63-1.2L192 314.5l149.3-134.4c6.594-5.877 16.69-5.361 22.62 1.188 5.88 6.612 5.38 15.812-1.22 22.612z"
  })));
};
export default SvgAngleDown;